<div id="case-view" class="page-layout simple fullwidth" perfect-scrollbar>

  <!-- CONTENT -->
  <div class="content p-24">
    <span *ngIf="loading">Loading Form...</span>
    <mat-horizontal-stepper *ngIf="!loading" (selectionChange)="stepperSelectionChange($event)" id="formStepper"
      #stepper>
      <mat-step *ngFor="let data of jsonSchema; let i = index;" label="Step {{ i+1 }}">
        <!--
            the onChanges
            this saves the form anytime the user changes something
            on load this gives an error because we are in dev
            https://github.com/angular/angular/issues/6005
            it seems it is ignorable
        -->
        <fieldset [disabled]="disableEdit" class="fieldset-caseview{{i}}">
          <json-schema-form *ngIf="i == currentPage" [form]="jsonSchema[currentPage]"
            [data]="jsonSchema[currentPage].data" framework="material-design" (isValid)="schemaFormValid($event,stepper);" (onChanges)="formChange($event)"
            (onSubmit)="goForward(stepper)" >
          </json-schema-form>
        </fieldset>

        <button mat-raised-button class="pull-right space " color="accent"  [disabled]="isSchemaFormValid" (click)="goForward(stepper,form)" 
          *ngIf="currentPage != ( jsonSchema.length - 1 )"
          style="margin-left: 10px; margin-top : 35px; float:right;text-transform: uppercase"
         >Next</button>&nbsp;

        <button mat-raised-button class="pull-right space" color="warn" (click)="goBack(stepper)"
          *ngIf="currentPage != 0"
          style="margin-left: 10px; margin-top : 35px ; float:right;text-transform: uppercase">Back</button>&nbsp;

      </mat-step>
    </mat-horizontal-stepper>

    <br />

    <div style="float:right">
      
      <button *ngIf=" (userRole == 'PETITIONER' || userRole == 'ATTORNEY' || userRole == 'GUARDIAN') && !(form =='2.3' || form == 'checkrDetails') && status == 'UPLOAD_DENIED_BY_JUDGE'" mat-raised-button class="pull-right"
        color="accent" (click)="resubmitCase('DUEFORM')" [class.loading]="isResubmitForm" [disabled]="disableSubmit || isResubmitForm" style="margin-left: 10px;margin-top : 35px;text-transform: uppercase ">
        Re-Submit Case</button>&nbsp;

      <button *ngIf="userRole == 'PETITIONER' && status == 'PETITION_REJECTED' && form =='2.3'" mat-raised-button class="pull-right"
        color="accent" (click)="resubmitCase()" style="margin-left: 10px;margin-top : 35px;text-transform: uppercase ">
        Re-Submit Case</button>&nbsp;

      <button [class.loading]="isResubmitForm" mat-raised-button class="pull-right space" color="accent"
        (click)="resubmitCase()" [disabled]="disableSubmit || isResubmitForm"
        *ngIf="caseId != null && userRole == 'PETITIONER' &&  form =='2.3'"
        style="margin-left: 10px; margin-top : 35px ;text-transform: uppercase">
        <div class="spinner"></div>
        <span class="label">Resubmit</span>
      </button>
      &nbsp;

      <button [class.loading]="formActionLoading" mat-raised-button class="pull-right space actionButton" color="accent"
        *ngIf="currentPage == ( jsonSchema.length - 1 ) && (userRole == 'PETITIONER' || userRole == 'ATTORNEY' || userRole == 'GUARDIAN') && !(form =='2.3' || form == 'checkrDetails') && status == 'SUBMIT_DUE_FORM'"
        (click)="submitFinal()" [disabled]="formActionLoading || isSchemaFormValid"
        style="text-transform: uppercase;">
        <div class="spinner"></div>
        <span class="label">Submit</span>
      </button>&nbsp;

      <button [class.loading]="formActionLoading" mat-raised-button class="pull-right space actionButton" color="accent"
        (click)="paymentMode()" [disabled]="formActionLoading || isSchemaFormValid"
        style="text-transform: uppercase;"
        *ngIf="currentPage == ( jsonSchema.length - 1 ) && caseId == null && formFee != 0 && (form =='2.3' || form == 'checkrDetails')">
        <div class="spinner"></div>
        <span class="label">Pay ${{ formFee/100 }} & Submit</span>
      </button>&nbsp;

      <button [class.loading]="formActionLoading" mat-raised-button class="pull-right space" color="accent" (click)="submitFinal()"
        *ngIf="currentPage == ( jsonSchema.length - 1 ) && caseId == null && formFee == 0 && form !='2.3'"
        style="margin-left: 10px; margin-top : 35px ;text-transform: uppercase;" [disabled]="formActionLoading">SUBMIT</button>&nbsp;

      <!-- <button [class.loading]="formActionLoading" mat-raised-button class="pull-right space" color="accent"
        (click)="submitFinal()" *ngIf="currentPage == ( jsonSchema.length - 1 )"
        style="margin-left: 10px; margin-top : 35px ;text-transform: uppercase;" [disabled]="formActionLoading">
        <div class="spinner"></div>
        <span class="label">SUBMIT</span>
      </button>&nbsp; -->

      <!-- <span *ngIf="caseNumberError" >Please fill the case Number</span>

      <mat-form-field *ngIf="userRole == 'CLERK' || userRole == 'JUDGE'">
            <input matInput type="text" placeholder="Case Number"
              name="caseNumber" [(ngModel)]="caseNumber">
      </mat-form-field> -->

      <button [class.loading]="formActionLoading" [disabled]="formActionLoadingDeny || formActionLoading"
        style="text-transform: uppercase" *ngIf="userRole == 'CLERK' || userRole == 'JUDGE'" mat-raised-button
        color="accent" (click)="approve()">
        <div class="spinner"></div>
        <span class="label">ACCEPT</span>
      </button>&nbsp;

      <button [class.loading]="formActionLoadingDeny" [disabled]="formActionLoadingDeny || formActionLoading"
        style="text-transform: uppercase" *ngIf="userRole == 'CLERK' || userRole == 'JUDGE'" mat-raised-button
        (click)="deny()" color="warn">
        <div class="spinner"></div>
        <span class="label">DENY</span>
      </button>&nbsp;
    </div>

    <br>
  </div>
  <br>
  <div class="commentSection">
    <comments *ngIf="commentId" [mode]="'HELLO'" [orgId]="org" [caseId]="commentId"></comments>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/case-view/case-view.component.html